import { Routes } from '@angular/router';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';

export const LEGAL_ROUTES: Routes = [
    {
        path: "kalpita-privacy-policy", component: PrivacyPolicyComponent,
        data: {
            title: 'Privacy Policy - Protecting Your Data | Kalpita Technologies',
            description: 'Kalpita Technologies is committed to protecting your privacy. Read our Privacy Policy to know how we collect, store, use, and secure your personal data.',
            keywords: 'Privacy Policy, Data Security, Compliance, User Experience, Manage Preferences, Transparency, Data Protection'
        }
    },
    {
        path: "kalpita-cookie-policy", component: CookiePolicyComponent,
        data: {
            title: 'Cookie Policy - How We Use Cookies | Kalpita technologies',
            description: 'Our Cookie Policy explains how we use cookies to personalize content, track performance, and improve your browsing experience while protecting your privacy.',
            keywords: 'Data Security, Compliance, Cookie Policy, User Experience, Manage Preferences, Transparency, Data Protection'
        }
    },
    {
        path: "kalpita-terms-of-use", component: TermsOfUseComponent,
        data: {
            title: 'Terms of Use - Legal Agreement | Kalpita Technologies',
            description: 'Please read our Terms of Use to understand the rules and guidelines for using our services.',
            keywords: 'Terms of Use, Legal Agreement, User Rights, Responsibilities, Compliance'
        }
    }
];